import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { TextField } from "@material-ui/core";
import DefaultButton from "../../styles/materialButtonStyle";

import { StyledBlockAction, StyledBlockLabel, StyledFormBlock, StyledInputBlock } from "../../styles/styledTabsForm";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const ProcessingBalanceRefilingForm = ({ payment, notification, setNotification, type, fetchAction }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    status: null,
    processedAmount: null
  });

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put("/api/" + type + "/" + payment.id, submitData, userAuthenticationConfig(false)).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: "Данные успешно изменены" });
        fetchAction();
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };


  const handleCancel = (event) => {
    event.preventDefault();
    setSubmitData({
      ...setSubmitData,
      status: "FAIL",
      processedAmount: "0"
    });
    setOpen(true);
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title="Подтверждение действия"
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <form
        onSubmit={event => {
          event.preventDefault();
          setSubmitData({
            ...setSubmitData,
            status: "PROCESSED",
            processedAmount: event.target.processedAmount.value
          });
          setOpen(true);
        }}
      >
        <StyledFormBlock>
          <StyledBlockLabel>
            Подверждение суммы
          </StyledBlockLabel>
          <StyledInputBlock>
            <TextField
              className="grid-form__input"
              variant="filled"
              label="Сумма"
              id="processedAmount"
              type="text"
              name="processedAmount"
              defaultValue={payment.amount}
            />
          </StyledInputBlock>
          <div className="clear-column" />
        </StyledFormBlock>
        <StyledFormBlock>
          <div className="clear-column" />
          <StyledBlockAction>
            <DefaultButton
              color="success"
              type="submit"
            >
              Сохранить
            </DefaultButton>
          </StyledBlockAction>
          <div className="clear-column" />
        </StyledFormBlock>
        <StyledFormBlock>
          <div className="clear-column" />
          <StyledBlockAction>
            <DefaultButton
              color="danger"
              type="button"
              onClick={handleCancel}
            >
              Отменить
            </DefaultButton>
          </StyledBlockAction>
          <div className="clear-column" />
        </StyledFormBlock>
      </form>
    </>
  );
};

export default ProcessingBalanceRefilingForm;